import React, { useState } from 'react';
import './FloatingWhatsApp.css';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
const FloatingWhatsApp = () => {
    const [isClosed, setIsClosed] = useState(false);

    const currentPath = window.location.pathname;
    let message = "Hi! I'm interested in working with Octalbees. Could we discuss my project?";
    
    if (currentPath.includes('/services/')) {
        const serviceName = currentPath.split('/').pop().replace(/-/g, ' ');
        message = `Hi! I'm interested in your ${serviceName} service. Could we discuss my project?`;
    }
    const whatsappUrl = `https://wa.me/919470506529?text=${encodeURIComponent(message)}`;

    if (isClosed) return null;

    return (
        <div className="unique-wa-container">
            
            {/* Main Button */}
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="unique-wa-btn">
                <div className="wa-pulse-ring"></div>
                <div className="wa-pulse-ring delayed"></div>
                <div className="wa-blob"></div>
                <div className="wa-icon-wrapper">
                    <FaWhatsapp className="wa-icon" />
                </div>
                {/* Close Button on Hover */}
                <button 
                    className="wa-close-btn" 
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIsClosed(true); }}
                    title="Close"
                >
                    <FaTimes />
                </button>
            </a>
        </div>
    );
};

export default FloatingWhatsApp;
